import React, { Fragment, useEffect, useState } from "react";
import { LayoutMain } from "@unisearch/theme/layout";
import { EvaluationForm } from "@modules/study/evaluation";
import { useRouter } from "next/router";
import { authService } from "@unisearch/auth";

const Evaluation = () => {
  const router = useRouter();
  const profileInfo = authService.getProfileData();

  //redirect to dashboard
  useEffect(() => {
    const fetchData = () => {
      if (
        (profileInfo && profileInfo.userTypeSlug != "student") ||
        (profileInfo && profileInfo.isProfileEvaluated == 1)
      ) {
        router.push(`/app/${profileInfo.userTypeSlug}`);
        return false;
      }
    };
    fetchData();
  }, [profileInfo, router]);

  return (
    <LayoutMain
      title="Profile Evaluation"
      metaTitle="Profile Evaluation"
      metaDescription="Apply to Universities Abroad with expert guidance from existing students"
      metaKeywords="profile, evaluation, study, abroad"
      footer={false}
      fixedPopup={false}
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/profile/evaluation`}
    >
      <EvaluationForm />
    </LayoutMain>
  );
};

export default Evaluation;
